module.exports = __webpack_public_path__ + "static/img/roll.a003111.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/roll.png
// module id = UcOn
// module chunks = 2